export const MOCK_USER = {
  id: 1,
  username: 'admin',
  password: 'admin123',
  displayName: '管理员',
  role: 'admin',
  canManageAccounts: true,
  isSuper: false
}
